// const allColors = [
//     [
//         '#10f581',
//         '#032c16'
//     ],
//     [
//         '#10f581',
//         '#032c16'
//     ],
//     [
//         '#fedf3a',
//         '#372c1f'
//     ],
//     [
//         '#862828',
//         '#e9e9e9'
//     ],
//     [
//         '#ffffff',
//         '#C0C0C0'
//     ],
//     [
//         '#ffffff',
//         '#0000FF'
//     ],
//     [
//         '#ffffff',
//         '#0000FF'
//     ],
//     [
//         '#ffffff',
//         '#0000FF'
//     ],
//     [
//         '#d38e1a',
//         '#3b755b',
//         '#000000',
//         '#ece7d4'
//     ],
//     [
//         '#0368bd',
//         '#c2332d',
//         '#0f0f0f',
//         '#ecddbe',
//     ],
//     [
//         '#e54f25',
//         '#017c88',
//         '#040202',
//         '#f1ddc2',
//     ],
//     [
//         '#5691ae',
//         '#f39e1a',
//         '#f0572f',
//         '#2b2728',
//         '#d2cbbe',
//     ],
//     [
//         '#87a4bf',
//         '#86aa9b',
//         '#1d1d1d',
//         '#fbf4ec',
//     ],
//     [
//         '#fd9a58',
//         '#252324',
//         '#fdebdf',
//     ],
//     [
//         '#000000',
//         '#ffffff',
//     ],
//     [
//         '#ffffff',
//         '#000000',
//     ],
//     [
//         '#000000',
//         '#ffffff',
//     ],
//     [
//         '#ffffff',
//         '#000000',
//     ],
//     [
//         '#000000',
//         '#ffffff',
//     ],
//     [
//         '#ffffff',
//         '#000000',
//     ],
//     [
//         '#000000',
//         '#ffffff',
//     ],
//     [
//         '#ffffff',
//         '#000000',
//     ],
//     [
//         '#000000',
//         '#ffffff',
//     ],
//     [
//         '#ffffff',
//         '#000000',
//     ],
//     [
//         '#017c88',
//         '#030202',
//         '#f1ddc2',
//     ],
//     [
//         '#f6f6f4',
//         '#ffffff',
//         '#3159ee',
//     ],
//     [
//         '#ff5937',
//         '#ff5937',
//         '#f6f6f4',
//     ],
//     [
//         '#ffc400',
//         '#009452',
//         '#252724',
//         '#fefefe',
//     ],
//     [
//         '#5d9d88',
//         '#ebb43b',
//         '#efebda',
//     ],
//     [
//         '#ff4c48',
//         '#567bae',
//         '#004996',
//         '#fff8e7',
//     ],
//     [
//         '#042050',
//         '#f2f2f2',
//         '#80c0f0',
//     ],
//     [
//         '#0b1a0b',
//         '#dd7440',
//         '#1bdf84',
//     ],
//     [
//         '#568486',
//         '#aa3941',
//         '#506638',
//         '#d5a630',
//         '#302b2b',
//         '#f3f0df',
//     ],
//     [
//         '#f1594a',
//         '#14a160',
//         '#f5b50e',
//         '#885fa4',
//         '#2969de',
//         '#1a1a1a',
//         '#e2e6e8',
//     ],
//     [
//         '#f1594a',
//         '#14a160',
//         '#f5b50e',
//         '#2969de',
//         '#000000',
//     ],
//     [
//         '#dd7440',
//         '#1bdf84',
//         '#0b1a0b',
//     ],
// ]
// export default allColors

const allColors = [
    [
        "#040309",
        "#3bca9e",
        "#1eb4eb",
        "#FFFFFF",
        "#f45d13",
        "#e794d4",
        "#ffce15",
    ], 
    [
        "#040309",
        "#3bca9e",
        "#1eb4eb",
        "#FFFFFF",
        "#f45d13",
        "#e794d4",
        "#ffce15",
    ], 
    [
        "#040309",
        "#3bca9e",
        "#1eb4eb",
        "#FFFFFF",
        "#f45d13",
        "#e794d4",
        "#ffce15",
    ], 
    [
        "#131F1D",
        "#083CE0",
        "#CA7B4F",
        "#C5DE49",
        "#D6D9DB",
        "#00D9A5",
    ], 
    [
        "#131F1D",
        "#083CE0",
        "#CA7B4F",
        "#C5DE49",
        "#D6D9DB",
        "#00D9A5",
    ], 
    [
        "#131F1D",
        "#3347B0",
        "#E8B4E7",
        "#CCF6E8",
    ], 
    [
        "#000000",
        "#9c52f2",
        "#b85e00",
        "#9c52f2",
        "#730f1f",
        "#9c52f2",
    ], 
    [
        "#000000",
        "#9c52f2",
        "#ffbf6e",
        "#0024cc",
        "#9c52f2",
    ], 
    [
        "#000000",
        "#0024cc",
        "#ffbf6e",
        "#9c52f2",
    ], 
    [
        "#000000",
        "#0024cc",
        "#ffbf6e",
        "#9c52f2",
    ], 
    [
        "#000000",
        "#ffbf6e",
        "#a6d40d",
        "#651300",
    ], 
    [
        "#000831",
        "#00d973",
        "#fa2b00",
        "#0000ff",
    ], 
    [
        "#3400a3",
        "#d50c42",
        "#19cc33",
    ],
    [
        "#111111",
        "#fefcfb",
    ],
    [
        "#111111",
        "#fefcfb",
    ],
    [
        "blue",
        "#ffffff",
    ], 
    [
        "blue",
        "#ffffff",
    ], 
    [
        "#000000",
        "#ff5ec4",
        "#a93400",
        "#1b8e13",
    ], 
    [
        "#00592e",
        "#fff",
        "#ff0000",
        "#ffff00",
        "#0E8DD2",
    ], 
    [
        "#0f261f",
        "#ffab00",
        "#bfabcc",
        "green",
    ], 
    [
        "#0f261f",
        "#faed8f",
        "#e62e73",
        "#0E8DD2",
    ],
    [
        "#06004f",
        "#cc1a97",
        "#9161f2",
        "#2619d1",
        "#ffb852",
        "#fa3219",
        'green'
    ],
    [
        "#172713",
        "#718600",
        "#f2ad78",
        "#f5f5b8",
        "#718600",
        "#f2ad78",
        "#f5f5b8",
        "#718600",
        "#f2ad78",
        "#f5f5b8",
        "#2619d1",
    ],
    [
        "#172713",
        "#718600",
        "#f2ad78",
        "#f5f5b8",
    ],
    [
        "#172713",
        "#00592e",
        "#d50c42",
        "#ff7399",
        "#00592e",
        "#d50c42",
        "#ff7399",
        "#FABF01",
    ],
    [
        "#172713",
        "#8c6510",
        "#ffb852",
        "#ffa6d9",
    ],
    [
        "#172713",
        "#328e13",
        "#ff616b",
        "#a6e6db",
    ],
    [
        "#10120F",
        "#F44A0F",
        "#0E8DD2",
        "#10971F",
        "#5AA316",
        "#E53F0F",
    ],
    [
        "#1f1816",
        "#FABF01",
        "#125FAF",
        "#01886A",
        "#6B5B99",
        "#E90013",
        "#FAEAD1",
    ],
    [
        "#020202",
        "#00BB70",
        "#0075CA",
        "#FDDC3F",
        "#FF6936",
    ],
    [
        "#2A1F1D",
        "#F0E0C6",
        "#DF4A33",
        "#FBAF3C",
        "#2A1F1D",
        "#7A999C",
        "#475B62",
    ],
    [
        "#022D8F",
        "#14a160",
        "#f9cd22",
        "#14a160",
        "#14a160",
        "#203b75",
    ],
    [
        "#000000",
        "#f1594a",
        "#14a160",
        "#acc1bc",
        "#d38e1a",
    ],
    [
        "#0609b1",
        "#ffffff",
        "#f0292f",
        "#fb6119",
        "#3e8741",
    ],
    [
        "#2619d1",
        "#ebd999",
        "#9b5348",
        "#00592e",
    ],
    [
        "#000000",
        "#f1594a",
        "#2969de",
        "#14a160",
    ],
    [
        "#000000",
        "#f1594a",
        "#2969de",
        "#14a160",
    ],
    [
        "#000000",
        "#f1594a",
        "#2969de",
        "#14a160",
    ],
    [
        "#06004f",
        "#202d85",
        "#f2ff26",
        "#bdf226",
        "#d50c42",
        "#9161f2",
    ],
    [
        "#2619d1",
        "#ffffff",
        "#2969ee",
        "#efcc7c",
    ],
    [
        "#2619d1",
        "#ffffff",
        "#2969ee",
        "#efcc7c",
    ],
    [
        "#2619d1",
        "#ffffff",
        "#2969ee",
        "#efcc7c",
    ],
    [
        "#2619d1",
        "#ffffff",
        "#2969ee",
        "#efcc7c",
    ],

]
export default allColors